import { Input } from "antd"
import { AuthFormItem } from "components/atoms/form"
import React from "react"

export const FormEmailInput = () => {
  return (
    <AuthFormItem
      label="メールアドレス"
      name="email"
      rules={[{ required: true, message: "メールアドレスを入力してください" }]}
    >
      <Input placeholder="test@example.com" />
    </AuthFormItem>
  )
}
